import FindingTemplate from "../../common/template/FindingTemplate";

const BookingConfirmed = () => {
    return <FindingTemplate title={'Booking confirmed'} subTitle={"instafix has confirmed your booking"}/>;
};

export default BookingConfirmed;